enum OrderStatusEnum {
  W = 'Aguardando pagamento',
  P = 'Pedido pago',
  C = 'Cancelado',
  U = 'Aguardando pagamento adicional'
};

export default OrderStatusEnum;
